import numeral from 'numeral'

import {
  DEBIT_CARD_CVV_LENGTH,
  DEBIT_CARD_EXPIRY_DATE_LENGTH,
  DEBIT_CARD_NO_LENGTH,
} from '@/domains/DebitCardDomain'
import { TransactionType } from '@/domains/TransferDomain'

import { getDifferenceInDays, getDifferenceInMonths } from './dateUtils'
import { isNumberFormat } from './numberUtils'

export const isUndefined = (value: any): boolean => {
  return value === undefined
}

export const isNull = (value: any): boolean => {
  return value === null
}

export const isEmpty = (value: any): boolean => {
  return value === ''
}

export const isZero = (value: number | string): boolean => {
  return numeral(value).value() === 0
}

export const isFunction = (value: any): boolean => {
  return typeof value === 'function'
}

export const isSameBankTransaction = (transactionType: TransactionType): boolean => {
  switch (transactionType) {
    case TransactionType.MY_ACCOUNT:
    case TransactionType.EQUALITY_CAPITAL:
    case TransactionType.LINE_AND_EQUALITY_CAPITAL:
    case TransactionType.PHONE_NUMBER_EQUALITY_CAPITAL:
      return true
    default:
      return false
  }
}

export const isOrUnderLength = <T>(value: string | Array<T>, max: number): boolean => {
  return value.length <= max
}

export const isUnderLength = <T>(value: string | Array<T>, max: number): boolean => {
  return value.length < max
}

export const isValidSchedulePaymentDateFormat = (value: string) => {
  return /(\d{4})\/(\d{2})\/(\d{2})/.test(value)
}

export const isValidRange = (from: number, to: number) => (value: number) => {
  return value >= from && value <= to
}

export const isValidCvv = (cvv: string) => {
  return cvv.length === DEBIT_CARD_CVV_LENGTH && isNumberFormat(cvv)
}

export const isValidDebitCardNo = (debitCardNo: string) => {
  return debitCardNo.length === DEBIT_CARD_NO_LENGTH && isNumberFormat(debitCardNo)
}

export const isValidDebitCardPinNo = (debitCardPinNo: string) => {
  return debitCardPinNo !== ''
}

export const isValidExpiryDateString = (expiryDateString: string) => {
  return (
    expiryDateString.length === DEBIT_CARD_EXPIRY_DATE_LENGTH &&
    isValidDateMMYYFormat(expiryDateString)
  )
}

export const isValidDateMMYYFormat = (val: string) => {
  return /^(0[1-9]|1[0-2])\/\d{2}$/.test(val)
}

export const isValidNote = (note: string) => {
  const isValidLength = note.length <= 40
  /* ATM기기에서 자동으로 생성하는 [ATM] Cash Withdrawal의 [] 문자 때문에 Note 수정이 안되는 이슈 발생*/
  const isValidCharacter = note.length === 0 || /^[A-Za-z0-9.,/[\]\-\s]+$/g.test(note)

  return isValidLength && isValidCharacter
}

export const isInvalidWeekdayInRange = (startDate: string, endDate: string) => {
  return getDifferenceInDays(startDate, endDate) < 7
}

const splitedDateByHyphen = (date: string) => date.split(/[^0-9]/).map(item => parseInt(item))

export const isInvalidMonthInRange = (startDate: string, endDate: string) => {
  const from = splitedDateByHyphen(startDate)
  const to = splitedDateByHyphen(endDate)
  const fromDate = new Date(from[0], from[1] - 1, from[2])
  const toDate = new Date(to[0], to[1] - 1, to[2])

  return getDifferenceInMonths(toDate, fromDate) === 0
}
